module.exports = __webpack_public_path__ + "static/img/banner.1e5aaf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/banner.jpg
// module id = Lf/U
// module chunks = 0